import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { resolveErrorMessage } from 'helpers'
import dialog from 'services/dialog'

// Apis
import { tagAcknowledged } from 'api/ecwt'

// Model
import Ecwt from 'models/Ecwt'

import Checkbox from 'antd/lib/checkbox/Checkbox'
import Box from 'ui/Box'
import Text from 'ui/Text'
import Button from 'ui/Button'

export const EcwtAcknowledge = ({ ecwt, onRefresh, onRaiseTicket }) => {
  const [checked, setChecked] = useState(ecwt.isAcknowledge)

  const onChangeAcknowledged = (e) => {
    setChecked(e.target.checked)
    dialog.confirm({
      size: 'mdx',
      title: 'Acknowledge e-CWT',
      message: (
        <div>
          <div>You are confirming that the e-CWT added {ecwt.createAtView}</div>
          <div>is true and correct. Are you sure you want to proceed?</div>
        </div>
      ),
      onConfirm: async ({ setLoading, setVisible: setConfirmVisible }) => {
        try {
          setLoading(true)
          await tagAcknowledged(ecwt.id)

          onRefresh()
        } catch (error) {
          setChecked(false)
          dialog.alert({
            title: await resolveErrorMessage(error),
          })
        } finally {
          setLoading(false)
          setConfirmVisible(false)
        }
      },
      onCancel: ({ setVisible }) => {
        setChecked(false)
        setVisible(false)
      },
      confirmText: 'Proceed',
    })
  }

  useEffect(() => {
    setChecked(ecwt.isAcknowledge)
  }, [ecwt])

  return (
    <Box style={{ margin: '10px 0 30px', padding: '20px 25px' }}>
      <Text size={18} bold color="#000000">
        Acknowledge e-CWT
      </Text>
      <Text color="#000000" paddingTop={10} paddingBottom={15}>
        Please confirm that you have reviewed the e-Creditable Withholding Tax
        above and that it is true and correct.
      </Text>

      <div className="d-flex">
        <Checkbox
          checked={checked}
          onChange={onChangeAcknowledged}
          disabled={ecwt.isAcknowledge}
        >
          <div>
            <Text color="#000000" bold={checked} size={16}>
              I confirm that the e-Creditable Withholding Tax above is true and
              correct
            </Text>

            {ecwt.isAcknowledge && (
              <Text color="#606060" italic>
                Confirmed {ecwt.acknowledgeDateView}
              </Text>
            )}
          </div>
        </Checkbox>
      </div>

      {!ecwt.isAcknowledge && (
        <Text color="#000000" paddingTop={15}>
          Should you have any concerns or questions regarding the document
          above, you can
          <Button
            variant="link"
            underline
            onClick={onRaiseTicket}
            style={{ minHeight: 'auto', marginTop: '-3px', marginLeft: '3px' }}
          >
            raise a ticket
          </Button>
        </Text>
      )}
    </Box>
  )
}

EcwtAcknowledge.propTypes = {
  ecwt: PropTypes.instanceOf(Ecwt),
  onRefresh: PropTypes.func,
  onRaiseTicket: PropTypes.func,
}

EcwtAcknowledge.defaultProps = {
  ecwt: new Ecwt(),
  onRefresh: () => {},
  onRaiseTicket: () => {},
}

export default EcwtAcknowledge
